import { getShareLinkBaseUrl, getWebxrBaseUrl } from '@/lib/productHosts';
import type { components } from '@/generated/contracts/api-v1';

/**
 * Share links (lureo-docs/Operations/Share_Link_Implementation.md). One permanent `live` link per
 * story, one `draft` link per version being tested; the slug is the capability and the scene id
 * never appears in the URL. The owner manages them under /api/v1/share-links.
 */
export type ShareLinkDto = components['schemas']['ShareLinkDto'];

export interface OriginShareLinks {
  live: ShareLinkDto | null;
  drafts: ShareLinkDto[];
}

/** The link a creator hands out: `<share host>/s/<slug>` on the minting origin (S1). */
export function shareLinkUrl(slug: string): string {
  return `${getShareLinkBaseUrl()}/s/${encodeURIComponent(slug)}`;
}

/**
 * The viewer's own address for a slug, for flows that open the browser viewer directly rather than
 * handing the link to someone. Null when the viewer host is not configured for this origin (3.7):
 * callers show an error state rather than a production link from the wrong environment.
 */
export function viewerShareUrl(slug: string, params?: Record<string, string>): string | null {
  const base = getWebxrBaseUrl();
  if (!base) return null;
  const query = params && Object.keys(params).length > 0 ? `?${new URLSearchParams(params).toString()}` : '';
  return `${base}/s/${encodeURIComponent(slug)}${query}`;
}
